import { render, staticRenderFns } from "./MaintenanceDetail.vue?vue&type=template&id=2854357c&scoped=true&"
import script from "./MaintenanceDetail.vue?vue&type=script&lang=js&"
export * from "./MaintenanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceDetail.vue?vue&type=style&index=0&id=2854357c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854357c",
  null
  
)

export default component.exports